import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { toCurrency } from '~/utils/formatters';
import {
  makeShippingProtectionClaimAction,
  makeShippingProtectionClaimLoader,
  redirect,
} from '~/utils/routing';

export const { loader, useLoaderData } = makeShippingProtectionClaimLoader(
  ({ context: { order, shippingProtectionClaim } }) => {
    const formatPrice = toCurrency(order.currencyCode);

    return {
      items: order.lineItems
        .filter((item) => !item.isCorsoProduct)
        .map((item) => ({
          ...item,
          unitDisplayPrice: formatPrice(item.unitPrice),
        })),
      selectedItemIds: shippingProtectionClaim.itemIds,
    };
  },
);

const schema = zfd.formData({
  items: zfd.repeatable(z.array(zfd.numeric()).min(1)),
});

export const { action, useActionResult } = makeShippingProtectionClaimAction(
  ({ formData }, appStore) => {
    const result = schema.safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Please select the order items affected.',
      };
    }

    appStore.dispatch(
      appStore.actions.shippingProtectionClaim.setItemIds(result.data.items),
    );

    return redirect('../meta');
  },
);
